import { SERVICEURI } from "../const/serviceuri";
import { mapLinkResponseToLinkService } from "./mapper/applicationlinkmapper";
import { getFromBlob, getFrameworkApiInstance } from '../instance/fetchframeworkapiInstance';

const getLinksForMenus = (userId: string, secName: string): Promise<any> => {
    const userIdStr = userId ?? '';
    const endPoint = SERVICEURI.GetLinksForMenusByUser.replace("{userid}", userIdStr).replace("{section}", secName);

    return new Promise((onSuccess, onFailure) => {
        getFrameworkApiInstance(endPoint).then(response => {
            const userProfile = mapLinkResponseToLinkService(response);
            onSuccess(userProfile);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
};

const getLinksForBlob = (userType: string, translate: string): Promise<any> => {
    return new Promise((onSuccess, onFailure) => {
        getFromBlob(userType, translate).then(response => {
            const userProfile = mapLinkResponseToLinkService(response);
            onSuccess(userProfile);
        }).catch((error: any) => {
            onFailure(error);
        });
    });
};



export default
    {
        getLinksForMenus, getLinksForBlob
    }